<template>
  <div class="table-responsive shadow bg-white">
    <b-table
      ref="appTable"
      stacked="md"
      primary-key="ID"
      selectable
      small
      bordered
      select-mode="single"
      selected-variant="primary"
      @row-selected="items => $emit('onSelectItem', items[0])"
      @row-dblclicked="onDblClicked"
      :fields="fields"
      :items="tableItemsProvider"
      :filter="search"
      :per-page="perPage"
      :current-page="currentPage"
      :busy="$store.state.isLoading"
      thead-class="bg-light"
      empty-filtered-text="Data tidak ditemukan"
      show-empty
      empty-text="Data kosong">

      <template #table-colgroup="scope">
        <col
          v-for="field in scope.fields"
          :key="field.key"
          :style="{ width: field.key === 'index' && '50px' }">
      </template>

      <template #head()="data">
        <small
          class="text-nowrap text-uppercase font-weight-bold"
          :class="{ 'text-right': data.column === 'index' }">
          {{ data.label }}
        </small>
      </template>

      <template #thead-top="data">
        <b-tr v-if="isLogisticSupplyReport">
          <b-th colspan="2"><span class="sr-only">Nama Barang</span></b-th>
          <b-th variant="secondary text-uppercase" colspan="3" class="text-center">Saldo Awal</b-th>
          <b-th variant="primary text-uppercase" colspan="3" class="text-center">Pembelian</b-th>
          <b-th variant="danger text-uppercase" colspan="3" class="text-center">Pemakaian</b-th>
          <b-th variant="success text-uppercase" colspan="3" class="text-center">Saldo Akhir</b-th>
        </b-tr>
<!-- 
        <b-tr v-if="isSalaryReport">
          <b-th colspan="6"><span class="sr-only">Pegawai</span></b-th>
          <b-th variant="danger text-uppercase" colspan="7" class="text-center">Potongan</b-th>
          <b-th colspan="2"><span class="sr-only">Hasil</span></b-th>
        </b-tr>
 -->
        
      </template>


      <template #cell(index)="data">
        <div class="text-md-right">
          {{ (data.index + 1) + (perPage * (currentPage - 1)) }}
        </div>
      </template>
<!-- 
      <template #cell(RowButton)="data">
        {{ data }}
        <a href="#" class="text-link" @click="onRowButtonClick(data.item)">{{ data.label }}</a>
      </template>
 -->
      <template #cell()="data">
        <span v-html="data.value"></span>
      </template>

    </b-table>

    <div class="mt-2 px-3">
      <slot name="caption" />
    </div>     

    <div class="mx-3 mt-3">
      <AppPagination :currentPage.sync="currentPage" :perPage.sync="perPage" :totalItems="totalItems" />
    </div>
  </div>
</template>

<script>
import AppPagination from '@/components/app/AppPagination.vue'

export default {
  components: { AppPagination },
  props: {
    apiUrl: String,
    perPage: {
      default: 10,
      type: Number
    },
    fields: Array,
    search: String,
    filter: Object,
    isLogisticSupplyReport: {
      default: false,
      type: Boolean
    },
    isSalaryReport: {
      default: false,
      type: Boolean
    }
  },
  created () {
    this.$parent.$on('refreshTable', this.refreshTable)
  },
  data () {
    return {
      currentPage: 1,
      // perPage: 10,
      totalItems: 0
    }
  },
  methods: {
    tableItemsProvider (ctx) {

      const params = {
        page: ctx.currentPage,
        pageSize: ctx.perPage,
        search: ctx.filter
      }

      if (this.filter) {
        for (const key of Object.keys(this.filter)) {
          if (this.filter[key]) {
            params[key] = this.filter[key]
          }
        }
      }

      const promise = this.$axios.get(this.apiUrl, { params })

      return promise.then(({ data }) => {
        this.totalItems = data.total

        return data.rows || []
      }).catch(() => {
        return [];
      })
    },
    refreshTable () {
      this.currentPage = 1
      this.$refs.appTable.refresh()
    },

    onDblClicked (item, index, event) {
      this.$emit('onDblClicked', item)
    }
  },
  watch: {
    search: function (val) {
      this.currentPage = 1
    }
  }
}
</script>
